import React, { useState, useMemo } from 'react';
import {
  HoldingsStructure,
  IndustryDistribution,
  HoldingsConcentration,
  HoldingsStyle
} from './components/HoldingsTab';
import ActionBar from './components/ActionBar.tsx';
import { ScrollArea } from '@/components/ui/scroll-area';
import { TotalData, HoldingsTabKeyNames } from './index.type';
import Summary from '@/components/Summary';

const HoldingsTab: React.FC<{
  totalData: Pick<TotalData, HoldingsTabKeyNames>;
}> = ({ totalData }) => {
  // 选中的指标
  const [selectedMetrics, setSelectedMetrics] = useState({
    holdingsStructure: true,
    industryDistribution: true,
    holdingsConcentration: false,
    holdingsStyle: false
  });

  // 全选状态
  const selectAll = useMemo(() => {
    const values = Object.values(selectedMetrics);
    return values.length > 0 && values.every(v => v);
  }, [selectedMetrics]);

  // 半选状态
  const isIndeterminate = useMemo(() => {
    const values = Object.values(selectedMetrics);
    const checkedCount = values.filter(v => v).length;
    return checkedCount > 0 && checkedCount < values.length;
  }, [selectedMetrics]);

  // 处理全选
  const handleSelectAll = (value: boolean) => {
    const newMetrics = { ...selectedMetrics };
    Object.keys(newMetrics).forEach(key => {
      newMetrics[key as keyof typeof selectedMetrics] = value;
    });
    setSelectedMetrics(newMetrics);
  };

  return (
    <>
      <ScrollArea className="scroll-area-block h-full w-full">
        <div className="rounded-lg bg-white p-4 pb-16">
          {/* 持仓总结 */}
          <Summary
            content={totalData.holding_product_review}
            isShowSuggestions={false}
          />

          {/* 持仓结构 */}
          <HoldingsStructure
            selectedMetrics={selectedMetrics}
            totalData={totalData}
          />

          {/* 行业分布 */}
          <IndustryDistribution
            selectedMetrics={selectedMetrics}
            totalData={totalData}
          />

          {/* 持仓集中度 */}
          <HoldingsConcentration
            selectedMetrics={selectedMetrics}
            totalData={totalData}
          />

          {/* 持仓风格 */}
          <HoldingsStyle
            selectedMetrics={selectedMetrics}
            totalData={totalData}
          />
        </div>
      </ScrollArea>
      {/* 操作栏 */}
      <ActionBar
        selectAll={selectAll}
        isIndeterminate={isIndeterminate}
        onUpdateSelectAll={handleSelectAll}
      />
    </>
  );
};

export default HoldingsTab;
